import { IS_WEB } from "./config";
import { outerWindow } from "./elements";
import MagicMock from "./magicMock";

export const App = __IFRAME__ ? outerWindow.App : require("@capacitor/app").App;
export const SplashScreen = __IFRAME__
  ? outerWindow.SplashScreen
  : require("@capacitor/splash-screen").SplashScreen;
export const StatusBar = IS_WEB
  ? MagicMock()
  : __IFRAME__
  ? outerWindow.StatusBar
  : require("@capacitor/status-bar").StatusBar;
export const NavigationBar = __IFRAME__
  ? outerWindow.NavigationBar
  : require("@hugotomazi/capacitor-navigation-bar").NavigationBar;
export const AdMob = __IFRAME__
  ? outerWindow.AdMob
  : require("@capacitor-community/admob").AdMob;
export const inAppPurchases = __IFRAME__
  ? outerWindow.inAppPurchases
  : window.inAppPurchases;
export const Device = __IFRAME__
  ? outerWindow.Device
  : require("@capacitor/device").Device;
export const FirebaseCrashlytics = __IFRAME__
  ? outerWindow.FirebaseCrashlytics
  : require("@capacitor-firebase/crashlytics").FirebaseCrashlytics;
export const Share = __IFRAME__
  ? outerWindow.Share
  : require("@capacitor/share").Share;
export const FirebaseAnalytics = __IFRAME__
  ? outerWindow.FirebaseAnalytics
  : require("@capacitor-community/firebase-analytics").FirebaseAnalytics;
export const NativeAudio = __IFRAME__
  ? outerWindow.NativeAudio
  : require("@capgo/native-audio").NativeAudio;
export const FileDownload = __IFRAME__
  ? outerWindow.FileDownload
  : require("capacitor-plugin-filedownload").FileDownload;
export const Filesystem = __IFRAME__
  ? outerWindow.Filesystem
  : require("@capacitor/filesystem").Filesystem;
export const FirebaseRemoteConfig = __IFRAME__
  ? outerWindow.FirebaseRemoteConfig
  : require("@capacitor-firebase/remote-config").FirebaseRemoteConfig;
export const Toast = __IFRAME__
  ? outerWindow.Toast
  : require("@capacitor/toast").Toast;
export const Haptics = IS_WEB
  ? MagicMock()
  : __IFRAME__
  ? outerWindow.Haptics
  : require("@capacitor/haptics").Haptics;
export const FirebaseDynamicLinks = __IFRAME__
  ? outerWindow.FirebaseDynamicLinks
  : require("@pantrist/capacitor-firebase-dynamic-links").FirebaseDynamicLinks;
export const FirebaseFirestore = __IFRAME__
  ? outerWindow.FirebaseFirestore
  : require("@capacitor-firebase/firestore").FirebaseFirestore;
export const RateApp = __IFRAME__
  ? outerWindow.RateApp
  : require("capacitor-rate-app").RateApp;
export const Network = __IFRAME__
  ? outerWindow.Network
  : require("@capacitor/network").Network;
export const Preferences = __IFRAME__
  ? outerWindow.Preferences
  : require("@capacitor/preferences").Preferences;
export const FirebaseAuthentication = __IFRAME__
  ? outerWindow.FirebaseAuthentication
  : require("@capacitor-firebase/authentication").FirebaseAuthentication;
export const FirebaseStorage = __IFRAME__
  ? outerWindow.FirebaseStorage
  : require("@capacitor-firebase/storage").FirebaseStorage;
export const Camera = __IFRAME__
  ? outerWindow.Camera
  : require("@capacitor/camera").Camera;
export const FilePicker = __IFRAME__
  ? outerWindow.FilePicker
  : require("@capawesome/capacitor-file-picker").FilePicker;

export const cordova = __IFRAME__ ? outerWindow.cordova : window.cordova;

if (__DEV__) {
  window.App = App;
  window.SplashScreen = SplashScreen;
  window.StatusBar = StatusBar;
  window.NavigationBar = NavigationBar;
  window.AdMob = AdMob;
  window.FirebaseCrashlytics = FirebaseCrashlytics;
  window.Device = Device;
  window.Share = Share;
  window.FirebaseAnalytics = FirebaseAnalytics;
  window.NativeAudio = NativeAudio;
  window.FileDownload = FileDownload;
  window.Filesystem = Filesystem;
  window.FirebaseRemoteConfig = FirebaseRemoteConfig;
  window.Toast = Toast;
  window.Haptics = Haptics;
  window.FirebaseDynamicLinks = FirebaseDynamicLinks;
  window.FirebaseFirestore = FirebaseFirestore;
  window.RateApp = RateApp;
  window.Network = Network;
  window.Preferences = Preferences;
  window.FirebaseAuthentication = FirebaseAuthentication;
  window.FirebaseStorage = FirebaseStorage;
  window.Camera = Camera;
  window.FilePicker = FilePicker;
}
